/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ClientFinderComponent } from '@app/shared/components/client-finder/client-finder.component';

@Injectable({
  providedIn: 'root',
})
export class ClientFinderService {
  constructor(private modalService: NgbModal) {}

  public open(data: object = {}, multiple: boolean = false): Promise<any> {
    const modal = this.modalService.open(ClientFinderComponent, { size: 'xl' as 'lg' });
    modal.componentInstance.data = data;
    modal.componentInstance.multiple = multiple;
    return modal.result;
  }
}
